const menu = [
  {
    icon: "dashboard",
    text: "Dashboard",
    link: "/",
  },
  {
    icon: "user-group",
    text: "MI Services",
    link: "/mi-services",
    active: false,
    subMenu: [
      {
        text: "Coaches & Mentor",
        link: "/coaches",
      },
      {
        text: "Consultants & Trainers",
        link: "/consultants",
      },
      {
        text: "Bookings",
        link: "/bookings",
      },
    ],
  },
  {
    icon: "tags",
    text: "Categories",
    link: "/categories",
  },
  // {
  //   icon: "setting-alt-fill",
  //   text: "Admin",
  //   active: false,
  //   subMenu: [
  //     // {
  //     //   text: "Roles",
  //     //   link: "/roles",
  //     // },
  //     // {
  //     //   text: "Role Permissions",
  //     //   link: "/role-permissions",
  //     // },
  //     // {
  //     //   text: "Sub Admin",
  //     //   link: "/administrators",
  //     // },
  //     {
  //       text: "JotForms",
  //       link: "/jot-forms",
  //     },
  //     {
  //       text: "Sign Up Categories",
  //       link: "/categories",
  //     },
  //   ],
  // },
  {
    icon: "calendar-alt",
    text: "Events",
    link: "/events",
  },
  {
    icon: "book-read",
    text: "MI Library",
    active: false,
    subMenu: [
      {
        text: "Assets",
        link: "/mi-library",
      },
      {
        text: "Categories",
        link: "/mi-library/categories",
      },
      {
        text: "Purchases",
        link: "/mi-library/purchases",
      },
    ],
  },
  {
    icon: "comments",
    text: "Forums",
    link: "/forums",
  },
  {
    icon: "bag",
    text: "Shops",
    active: false,
    subMenu: [
      {
        text: "Products",
        link: "/products",
      },
      {
        text: "Orders",
        link: "/orders",
      },
    ],
  },
  {
    icon: "pen2",
    text: "Branding Submissions",
    link: "/branding-submissions",
  },
  {
    icon: "mail",
    text: "Contact Us",
    link: "/contact-us",
  },
  {
    icon: "users",
    text: "Manage Users",
    link: "/users",
  },
  {
    icon: "share",
    text: "Manage Social",
    link: "/posts",
  },
  // {
  //   icon: "col-3s",
  //   text: "Subscriptions",
  //   link: "/subscriptions",
  // },
  {
    icon: "flag",
    text: "Reports",
    link: "/reports",
  },
];
export default menu;
